import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// 1. Import Provider and store
import { Provider } from 'react-redux';
import { store } from './redux/store';
// Global design system — imported last so it unifies Bootstrap + page CSS
import './assets/css/theme.css';
// Shared micro-interactions (card entrance, row stagger, press feedback)
import './assets/css/animations.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     {/* 2. Wrap App with Provider */}
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>
// );

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);